import { useQuery } from '@tanstack/react-query'
import { ActivationStatusView, Button } from '@lipaflow/ui'
import { apiErrorMessage } from '@lipaflow/shared'
import { adminService } from '../../services/admin'

/**
 * The customer's activation status (R15, 2026-10-29): the same steps, owners
 * and blockers the customer sees on their "Getting live" page, plus what
 * LipaFlow does next on the steps waiting on us.
 */
export function ActivationSection({ tenantId }: { tenantId: string }) {
  const status = useQuery({
    queryKey: ['tenants', tenantId, 'activation'],
    queryFn: () => adminService.getActivation(tenantId),
    staleTime: 0,
  })
  return (
    <section aria-label="Activation" className="rounded-card border border-hairline p-4 space-y-3">
      <h3 className="text-body-sm font-medium text-ink">Activation</h3>
      {status.isLoading ? (
        <p role="status" className="text-body-sm text-ink-muted">Loading activation…</p>
      ) : status.isError || !status.data ? (
        <div role="alert" className="flex flex-wrap items-center gap-3 text-body-sm text-warning">
          {apiErrorMessage(status.error, "Couldn't load their activation status.")}
          <Button size="sm" variant="secondary" onClick={() => status.refetch()}>Try again</Button>
        </div>
      ) : (
        <ActivationStatusView status={status.data} audience="staff" />
      )}
    </section>
  )
}
